// Mobile menu toggle
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.menu-btn');
  if (!btn) return;
  var nav = document.querySelector('.site-nav ul');
  if (!nav) return;
  var open = nav.style.display === 'flex';
  nav.style.display = open ? 'none' : 'flex';
  if (!open) {
    nav.style.position = 'absolute';
    nav.style.flexDirection = 'column';
    nav.style.top = '76px';
    nav.style.left = '0';
    nav.style.right = '0';
    nav.style.background = 'var(--steel-050)';
    nav.style.padding = '20px 28px';
    nav.style.gap = '18px';
    nav.style.borderBottom = '1px solid var(--steel-200)';
  }
});

// Live cart count (reads Shopify cart)
function refreshCartCount() {
  var label = document.querySelector('.cart b');
  if (!label) return;
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { label.textContent = '(' + cart.item_count + ')'; })
    .catch(function () {});
}
document.addEventListener('DOMContentLoaded', refreshCartCount);
